import ThemeOptions from './ThemeOptions';
import auth from './auth'
export default {
    ThemeOptions,
    auth
};


// WEBPACK FOOTER //
// src/reducers/index.js